import { connect } from 'react-redux'
import PageAppraisals from './PageAppraisals.component'
import { loadNewsBySector } from '../../actions/news'
import { loadDirectorsBySector, loadBrokers, loadServices, loadClients } from '../../actions/appraisals'
import { setPhone } from '../../actions/header'
import { TEL_APPRAISALS } from '../../constants/phones'

const mapStateToProps = (state) => {
  return {
    news: state.news.sectorList,
    directors: state.appraisals.directors,
    brokers: state.appraisals.brokers,
    services: state.appraisals.services,
    clients: state.appraisals.clients
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPhone: () => dispatch(setPhone(TEL_APPRAISALS)),
    loadNewsBySector: () => dispatch(loadNewsBySector(4)),
    loadDirectors: () => dispatch(loadDirectorsBySector(4)),
    loadBrokers: () => dispatch(loadBrokers(4)),
    loadServices: () => dispatch(loadServices()),
    loadClients: () => dispatch(loadClients())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageAppraisals)



// WEBPACK FOOTER //
// ./src/features/PageAppraisals/PageAppraisals.container.js